import { CometChat } from '@/plugins';
import { Dashboard } from '@/components';

export const MessengerPage = () => (
  <Dashboard isChecked={true} openLogIn>
    <CometChat />
  </Dashboard>
);
